import React from "react";
import MyRoutes from "./routes";
import { ThemeProvider } from "./contexts/ThemeContext";
import "./App.css";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <MyRoutes />
      </div>
    </ThemeProvider>
  );
}

export default App;
